import { Link } from 'react-router-dom';
import homeVideoCat from '@assets/images/home-video-cat.webp';



const VideoBoxCollar = (): JSX.Element => {

	return (
		<div className='video-box-collar'>

			<ul>
				<li>nebrání v&nbsp;prostorové orientaci</li>
				<li>umožní pohyb</li>
				<li>umožní bezproblémové krmení</li>
				<li>zajistí klidný spánek</li>
				<li>nedráždí pokožku</li>
				<li>snižuje riziko zapařenin</li>
				<li>snižuje stres a&nbsp;může tak&nbsp;přispět k&nbsp;hojení</li>
				<li>je odolný proti kočičím drápkům a&nbsp;brání zadrápnutí</li>
			</ul>

			<div className='video-placeholder-image'>
				<img src={homeVideoCat} alt='video-placeholder-photo' />
			</div>
			
			<p>Snažíme se, aby&nbsp;naše límce byly také skvělým řešením pro&nbsp;kočičí alergiky, kterým brání v&nbsp;kontaktu s&nbsp;postiženou kůží. VETlímce šijeme z&nbsp;odolné, omyvatelné textilie se&nbsp;specifickými vlastnostmi (tzv. kočárkoviny). Ta&nbsp;je&nbsp;velmi praktická na&nbsp;údržbu - při&nbsp;běžném znečistění límec stačí pouze otřít. VETlímec tak může vaší kočce sloužit dlouhodobě, třeba i&nbsp;celý život.</p>

			<p className='link-text'>{'Máte doma náš produkt a\u00a0ztratili jste návod k použití? Nezoufejte a\u00a0stáhněte si jej '}
				<Link to={'https://vetlimce.blob.core.windows.net/vcz/Navod-k-pouziti-kocka-limec-2024.pdf'} className='disable-selection' target='_blank'>
					ZDE
				</Link>.
			</p>

		</div>
	);
};

export default VideoBoxCollar;